import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OrderListItem } from 'reg-hub-common';
import { OrderListRepositoryService } from '../../services/order-list/order-list-repository.service';

@Component({
    selector: 'app-pending-order-list',
    templateUrl: './pending-order-list.component.html',
    styleUrls: ['./pending-order-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PendingOrderListComponent {

  @Input() data: OrderListItem[] = [];
  @Input() total: number = 0;
  @Input() loading: boolean = false;

  protected displayedColumns = [
    'referenceNumber',
    'orderTypeID',
    'jurisdiction',
    'messages'
  ]

  constructor(
    protected repo: OrderListRepositoryService,
    protected router: Router) { }

  protected onViewAll() {
    let params = {
      status: ['Pending','OutOfRegistryHours','AwaitingHighVolumeResults','RegistryOutage','Exception'],
      sortColumn: 'added',
      sortDirection: 'desc'
    }

    this.router.navigate(['/orders'], { queryParams: params })
  }
}
